export default "__VITE_ASSET__DVCd$3RC__"